module.exports = __webpack_public_path__ + "media/images/introduce_2-d1d84a8844dfce2b3c2c96fc28a0dfd1.jpg";